import { render, staticRenderFns } from "./ArtShowcase.vue?vue&type=template&id=1179ae12&"
import script from "./ArtShowcase.vue?vue&type=script&lang=ts&"
export * from "./ArtShowcase.vue?vue&type=script&lang=ts&"
import style0 from "./ArtShowcase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports